<template>
 <div>
    <b-field :label="label">
      <qd-taginput
        v-model="itemsSelected"
        :data="filteredItems"
        :loading="isLoad"
        autocomplete
        :confirm-keys="confirmKeys"
        :before-adding="beforeAdding"
        field="libelle"
        type="is-primary"
        @typing="gestionTyping"
        @input="setItems"
        @remove="setItems"
        ref="tag">
        <template #selected="{ tags }">
          <b-tag
            :style="{ backgroundColor: tag.couleur }"
            v-for="(tag, index) in tags" :key="index"
            @close="$refs.tag.removeTag(index, $event)"
            :type="chooseTagType(tag)"
            closable>
            {{tag.libelle}}
          </b-tag>
        </template>
        <template slot="header">
          <a @click="checkPermissions(permMarque.maj) ? openPopup() : showPopUp()">
            <a class="lien"
            :class="{ 'text-access-no-permission' : !checkPermissions(permMarque.maj)}">
              <span> {{ $t('editionClient.actions.addMarque') }}</span>
            </a>
          </a>
        </template>
        <template slot="empty">
          <div v-if="!isLoad">
            {{$t('general.autocomplete.noRslt')}}
          </div>
          <div v-else>{{$t('general.autocomplete.search')}}</div>
        </template>
      </qd-taginput>
    </b-field>
    <b-modal v-model="openPopUpAddMarque" has-modal-card class="modal">
      <pop-up-add-edit-parametre-generique
        :parametrage="newMarque"
        :typeParametre="parametreKey"
        @reloadParametrage="reload"/>
    </b-modal>
 </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import { pGetAll } from '@/api/parametre/index';
import { MARQUE } from '@/configuration/general/permissionsParametrageConf';
import popUpAddEditParametreGenerique from '@/components/general/p_addEditParametreGenerique';
import genererParametrageGenerique from '@/services/parametrage/generation/genererParametrageGenerique';
import { chooseTagType } from '@/services/parametrage/tag/tagService';

const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    field: {
      type: String,
      required: true,
    },
    parametreKey: {
      type: String,
      required: true,
    },
  },
  components: {
    popUpAddEditParametreGenerique,
  },
  data() {
    return {
      filteredItems: [],
      itemsSelected: [],
      isLoad: false,
      itemsBase: [],
      confirmKeys: ['Tab', 'Enter'],
      openPopUpAddMarque: false,
      permMarque: MARQUE,
      newMarque: genererParametrageGenerique(),
      search: null,
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    items: {
      get() {
        return this.value ?? [];
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    chooseTagType,
    setItems() {
      const list = this.itemsBase.filter(tm => this.itemsSelected
        .map(m => m.id).includes(tm.marqueId));
      this.itemsSelected.forEach((el) => {
        if (!list.map(m => m.marqueId).includes(el.id)) {
          list.push({
            marqueId: el.id,
          });
        }
      });
      this.items = cloneDeep(list);
    },
    openPopup() {
      this.newMarque.libelle = this.search;
      this.openPopUpAddMarque = true;
    },
    beforeAdding(value) {
      return !this.itemsSelected.some((item) => {
        if (typeof value === 'object') return item.id === value.id;
        return item.libelle.toLowerCase() === value.toLowerCase();
      });
    },
    gestionTyping(text) {
      this.search = text;
      if (!this.search) return;
      this.filteredItems = [];
      this.getItemsData();
    },
    getItemsData: debounce(async function loadData() {
      this.isLoad = true;
      try {
        const results = (await pGetAll(this.parametreKey, {
          query: {
            auto: this.search,
            actif: true,
          },
        })).data.result.items;
        this.filteredItems = results.filter((item) => {
          return !this.itemsSelected.map(i => i.id).includes(item.id);
        });
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        this.isLoad = false;
      }
    }, 300),
    reload(result) {
      this.$refs.tag.newTag = null;
      this.itemsSelected.push(result);
      this.setItems();
    },
  },
  mounted() {
    this.itemsBase = cloneDeep(this.items);
    if (this.items.length) {
      this.itemsSelected = this.items.map(el => el[this.field]);
    }
  },
};
</script>
